import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import AppartmentDetails from './views/AppartmentDetails.vue';
import Views from './views/Views.vue';
import appartmentData from './data/appartments';
import viewsData from './data/views';

Vue.use(Router);

export default new Router({
	base: process.env.BASE_URL,
	mode: 'history',
	routes: [
		{
			component: Home,
			name: 'home',
			path: '/',
		},
		{
			component: AppartmentDetails,
			name: 'dpto-3.5-amb',
			path: '/dpto-3.5-amb',
			props: {
				details: appartmentData['dpto-3.5-amb'],
			},
		},
		{
			component: AppartmentDetails,
			name: 'loft',
			path: '/loft',
			props: {
				details: appartmentData.loft,
			},
		},
		{
			component: AppartmentDetails,
			name: 'dpto-2.5-amb',
			path: '/dpto-2.5-amb',
			props: {
				details: appartmentData['dpto-2.5-amb'],
			},
		},
		{
			component: Views,
			name: 'vistas',
			path: '/vistas',
			props: {
				details: viewsData,
			},
		},
		// {
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			// component: async () => import('./views/About.vue'),
			// name: 'about',
			// path: '/about',
		// },
	],
});
